<template>
 <page>

   <head-nav :title="date">
      <icon-button-back slot="left"></icon-button-back>
      <icon-button-home slot="right"></icon-button-home>
    </head-nav>

  <scroll-page>
    <page-padding>

      <text-block><b>{{item.title}}</b></text-block>
      <div class="start_time">
       {{$t("language.time_from")}}:{{item.start_time}}
    </div>
    <div class="end_time">
       {{$t("language.time_to")}}:{{item.end_time}}
    </div>
     
    
    <text-block> {{item.descr}}</text-block>
  
    </page-padding>
   </scroll-page>
   </page>
</template>

<script>

import { mapState } from 'vuex';
import Page from '../pages/Page.vue';
import PagePadding from '../components/PagePadding.vue';
import TextBlock from '../components/TextBlock.vue';
import HeadNav from '../components/HeadNav.vue';
import IconButtonHome from '../components/buttons/IconButtonHome.vue';
import IconButtonBack from '../components/buttons/IconButtonBack.vue';
import ScrollPage from '../components/ScrollPage.vue';

export default {
  name: 'view-calendar-item-page',
  data:function(){
    return{
      item_id:this.$route.params.id,
      date:" ",
      item:{},
    }
  },
  computed:{
     ...mapState([
       'calendar'
       ]), 
  },
  components: {
    PagePadding,
    HeadNav,
    IconButtonHome,
    IconButtonBack,
    Page,
    TextBlock,
    ScrollPage,
  },
  methods:{
   loadCalendarItem(){
      // load calendar item
      var payload={id:this.item_id}
      this.$store.dispatch('get_calendar_item',payload).then(result=>{
        this.date=result.data.title;
        this.item.start_time=result.data.start_time;
        this.item.end_time=result.data.end_time;
        this.item.title=result.data.date;
        this.item.descr=result.data.description;
      })
    },
  },
  mounted(){
   
   this.loadCalendarItem();
   
    
  }
}

</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.start_time{
  margin-bottom:10px;
  
  
}
.end_time{
  margin-bottom:10px;
  
 
}
</style>
